export const TIP_PAYOUT_DATE_PRESET_ALL = 'all';
export const TIP_PAYOUT_DATE_PRESET_WEEK = 'week';
export const TIP_PAYOUT_DATE_PRESET_MONTH = 'month';
export const TIP_PAYOUT_DATE_PRESET_CUSTOM = 'custom';

export const TIP_PAYOUT_DATE_PRESETS = [
    { id: TIP_PAYOUT_DATE_PRESET_ALL, label: 'All Owed' },
    { id: TIP_PAYOUT_DATE_PRESET_WEEK, label: 'This week' },
    { id: TIP_PAYOUT_DATE_PRESET_MONTH, label: 'This month' },
    { id: TIP_PAYOUT_DATE_PRESET_CUSTOM, label: 'Custom' },
];

export function formatLocalDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export function getTodayLocalDateString() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return formatLocalDate(today);
}

export function getPresetDateRange(preset) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const endDate = formatLocalDate(today);

    if (preset === TIP_PAYOUT_DATE_PRESET_WEEK) {
        const start = new Date(today);
        start.setDate(start.getDate() - 6);
        return { startDate: formatLocalDate(start), endDate };
    }

    if (preset === TIP_PAYOUT_DATE_PRESET_MONTH) {
        const start = new Date(today.getFullYear(), today.getMonth(), 1);
        return { startDate: formatLocalDate(start), endDate };
    }

    return { startDate: null, endDate: null };
}

export function buildTipPayoutDateRangeFromState(state) {
    const preset = state?.tipPayoutDatePreset || TIP_PAYOUT_DATE_PRESET_ALL;

    if (preset === TIP_PAYOUT_DATE_PRESET_ALL) {
        return null;
    }

    if (preset === TIP_PAYOUT_DATE_PRESET_CUSTOM) {
        const startDate = state?.tipPayoutCustomStartDate || '';
        const endDate = state?.tipPayoutCustomEndDate || '';
        if (!startDate && !endDate) {
            return null;
        }
        return { startDate, endDate };
    }

    return getPresetDateRange(preset);
}

export function buildTipPayoutDateQueryParams(dateRange) {
    if (!dateRange) {
        return {};
    }

    const params = {};
    if (dateRange.startDate) {
        params.startDate = dateRange.startDate;
    }
    if (dateRange.endDate) {
        params.endDate = dateRange.endDate;
    }
    return params;
}

export function buildTipPayoutDateRangeKey(dateRange) {
    if (!dateRange) {
        return 'all';
    }

    const startDate = dateRange.startDate || '';
    const endDate = dateRange.endDate || '';
    return `${startDate}|${endDate}`;
}

export function buildTipPayoutDateRequestBody(dateRange, base = {}) {
    const body = { ...base };
    if (dateRange?.startDate) {
        body.StartDate = dateRange.startDate;
    }
    if (dateRange?.endDate) {
        body.EndDate = dateRange.endDate;
    }
    return body;
}
